import React from 'react';
import { Box, Typography } from '@mui/material';
import SocialCounters from './social-counters';

export function FoundersNote() {
  return (
    <Box
      mt={2}
      mx="auto"
      style={{
        maxWidth: '60ch',
      }}
    >
      <Typography variant="h2" align="center" paragraph={true}>
        List od założycieli
      </Typography>
      <Typography variant="body1" paragraph={true}>
        W 2020 roku co czwarty maturzysta nie zdał matury, a tylko co drugi
        otrzymał wynik większy niż 50%. Zaległości w nauce matematyki powstają
        już w podstawówce. Uczniowie mając początkowo problem z ułamkami
        następnie z wyrażeniami algebraicznymi w najmłodszych latach za jakiś
        czas mają trudności w zrozumieniu trudniejszych zagadnień takich jak
        funkcje czy ciągi.
      </Typography>
      <Typography variant="body1" paragraph={true}>
        Pandemia oraz nauczanie zdalne dodatkowo pogłębiły ten problem. Nie
        wszyscy uczniowie potrafili skupić się na lekcjach online, co wpłynęło
        na powstanie dużych zaległości. W dodatku korepetycje są drogie i nie
        dla wszystkich równie dostępne.
      </Typography>
      <Typography variant="body1" paragraph={true}>
        Dlatego stworzyliśmy aplikację z kursem z matematyki, która skupia się
        na słabych stronach, jest dostępna zawsze pod ręką oraz daje możliwość
        zdania matury, dostania się do wymarzonego liceum czy uczelni.
      </Typography>
      <Typography variant="body1" paragraph={true}>
        Nasz kurs od zera tłumaczy wszystkie zagadnienia i pozwala uczniowi na
        zrozumienie materiału z każdej klasy szkoły ponadpodstawowej oraz
        podstawowej.
      </Typography>
      <Typography variant="body1" paragraph={true}>
        Na dzień dzień dzisiejszy pomogliśmy blisko stu tysiącom uczniów
        nadrobić zaległości z matematyki oraz zdać egzamin ósmoklasisty i
        maturalny jak najlepiej.
      </Typography>
      <Typography variant="body1" paragraph={true}>
        Maciej & Kamila
      </Typography>
      <Typography variant="body1" paragraph={true}>
        Wejdź koniecznie na nasz Instagram i TikTok, znajdziesz tam dużo
        darmowych materiałów oraz informacje o najbliższych darmowych grupowych
        korepetycjach live.
      </Typography>
      <SocialCounters />
    </Box>
  );
}

export default FoundersNote;
